import {
  User,
  Pencil,
  Users,
  AtSign,
  Bell,
  List,
  Bookmark,
  Copy,
  Trash2,
  MapPin,
  Star,
  Gift,
  Lock,
} from "lucide-react";

/* Profile page tour, ported from the mobile "Profile" mockup.
   Two mockup steps are intentionally dropped for the real page:
   - the notification-channel POPUP step (mockup opens a floating panel; the
     real app opens a Bootstrap modal, so instead the notification step below
     explains that tapping edit opens the Email/Push/In-app channel choices), and
   - "Rate the app", which has no equivalent control on this page.
   Card-only steps whose target may be absent (no saved paychecks / cities, or
   Change password hidden for social-login accounts) are auto-skipped by the
   engine when the element isn't present. */
export default function getProfileTourSteps() {
  return [
    {
      cardSelector: '[data-tour="pf-profile"]',
      targetSelector: '[data-tour="pf-profile"]',
      icon: <User />,
      title: "Profile area",
      text: "Your avatar, name, and community stats live here.",
    },
    {
      cardSelector: '[data-tour="pf-profile"]',
      targetSelector: '[data-tour="pf-edit"]',
      icon: <Pencil />,
      title: "Edit",
      text: "Tap to update your photo and profile details.",
    },
    {
      cardSelector: '[data-tour="pf-profile"]',
      targetSelector: '[data-tour="pf-followers"]',
      icon: <Users />,
      title: "Followers",
      text: "People following your posts.",
    },
    {
      cardSelector: '[data-tour="pf-profile"]',
      targetSelector: '[data-tour="pf-following"]',
      icon: <Users />,
      title: "Following",
      text: "People whose posts you follow.",
    },
    {
      cardSelector: '[data-tour="pf-nameemail"]',
      targetSelector: '[data-tour="pf-name"]',
      icon: <User />,
      title: "Name",
      text: "The name shown on your profile.",
    },
    {
      cardSelector: '[data-tour="pf-nameemail"]',
      targetSelector: '[data-tour="pf-email"]',
      icon: <AtSign />,
      title: "Email",
      text: "The email tied to your account.",
    },
    {
      cardSelector: '[data-tour="pf-notif"]',
      targetSelector: '[data-tour="pf-notif-edit"]',
      icon: <Bell />,
      title: "Notification Settings",
      text: "Tap the edit icon on any row to choose how you're notified — Email, Push, or In-app.",
    },
    {
      cardSelector: '[data-tour="pf-other-head"]',
      targetSelector: '[data-tour="pf-other-head"]',
      icon: <List />,
      title: "Other Details",
      text: "Your full profile. Each edit icon opens that field's detail page to make changes.",
    },
    {
      cardSelector: '[data-tour="pf-paychecks"]',
      targetSelector: '[data-tour="pf-paychecks"]',
      icon: <Bookmark />,
      title: "Your saved paychecks",
      text: "Paycheck scenarios you've saved for comparison.",
    },
    {
      cardSelector: '[data-tour="pf-pc1"]',
      targetSelector: '[data-tour="pf-pc1"]',
      icon: <Bookmark />,
      title: "A saved paycheck",
      text: "Open it in the calculator, or use the actions to manage it.",
    },
    {
      cardSelector: '[data-tour="pf-pc1"]',
      targetSelector: '[data-tour="pf-rename"]',
      icon: <Pencil />,
      title: "Rename",
      text: "Give this saved paycheck a new name.",
    },
    {
      cardSelector: '[data-tour="pf-pc1"]',
      targetSelector: '[data-tour="pf-dup"]',
      icon: <Copy />,
      title: "Duplicate",
      text: "Copy it as a starting point for a new scenario.",
    },
    {
      cardSelector: '[data-tour="pf-pc1"]',
      targetSelector: '[data-tour="pf-del"]',
      icon: <Trash2 />,
      title: "Delete",
      text: "Remove this saved paycheck.",
    },
    {
      cardSelector: '[data-tour="pf-cities"]',
      targetSelector: '[data-tour="pf-cities"]',
      icon: <MapPin />,
      title: "Saved cities",
      text: "Cities you've bookmarked to compare pay and cost of living.",
    },
    {
      cardSelector: '[data-tour="pf-city1"]',
      targetSelector: '[data-tour="pf-city1"]',
      icon: <MapPin />,
      title: "A saved city",
      text: "Your role, net salary, and typical home value for this city.",
    },
    {
      cardSelector: '[data-tour="pf-city1"]',
      targetSelector: '[data-tour="pf-city-del"]',
      icon: <Trash2 />,
      title: "Delete",
      text: "Remove this city from your saved list.",
    },
    {
      cardSelector: '[data-tour="pf-sub"]',
      targetSelector: '[data-tour="pf-sub"]',
      icon: <Star />,
      title: "Subscription",
      text: "Manage your plan and billing.",
    },
    {
      cardSelector: '[data-tour="pf-ref"]',
      targetSelector: '[data-tour="pf-ref"]',
      icon: <Gift />,
      title: "Referral",
      text: "Invite friends and earn rewards.",
    },
    {
      cardSelector: '[data-tour="pf-delacct"]',
      targetSelector: '[data-tour="pf-delacct"]',
      icon: <Trash2 />,
      title: "Delete Account",
      text: "Permanently close your account.",
    },
    {
      cardSelector: '[data-tour="pf-pw"]',
      targetSelector: '[data-tour="pf-pw"]',
      icon: <Lock />,
      title: "Change password",
      text: "Update your account password.",
    },
  ];
}
